import { useSelector } from 'react-redux';

const LINKEDIN_SHARE_POST_URL = 'https://www.linkedin.com/shareArticle';
const LINKEDIN_ADD_TO_PROFILE_URL = 'https://www.linkedin.com/profile/add';
const LINKEDIN_DOXYCHAIN_ORG_ID = 14021793;

const constructUrl = (baseUrl, params) => {
  const url = new URL(baseUrl);
  url.search = new URLSearchParams(params).toString();
  return url.toString();
};

const extractFromUnix = (timestamp) => {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  return { year, month };
};

const extractFromISO = (isoString) => {
  const date = new Date(isoString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  return { year, month };
};

const useLinkedInSharingLinks = () => {
  const document = useSelector((state) => state.documentDisplayStore.document);

  const explorerCertificateLink = `${process.env.REACT_APP_EXPLORER_FRONT_URL}document/${document.id}`;

  const createPostLink = constructUrl(LINKEDIN_SHARE_POST_URL, {
    url: explorerCertificateLink,
  });

  const issueDate = document?.createdAt ? extractFromISO(document?.createdAt) : undefined;
  const expirationDate = document?.additionalAttributes?.expiresOn
    ? extractFromUnix(document?.additionalAttributes?.expiresOn)
    : undefined;

  const addToProfileLink = constructUrl(LINKEDIN_ADD_TO_PROFILE_URL, {
    name: document.name,
    organizationId: LINKEDIN_DOXYCHAIN_ORG_ID,
    issueYear: issueDate?.year,
    issueMonth: issueDate?.month,
    expirationYear: expirationDate?.year,
    expirationMonth: expirationDate?.month,
    certId: document.id,
    certUrl: explorerCertificateLink,
  });

  return {
    createPostLink,
    addToProfileLink,
  };
};

export default useLinkedInSharingLinks;
